import { Component, OnInit } from '@angular/core';
import { MessageService } from '../../services/message.service';
import { AppService } from '../../services/app.service';

const textCode = 'FOOTER_TEXT';

@Component({
	selector: 'app-footer',
	templateUrl: './footer.component.html',
	styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {
    constructor(
        private readonly app: AppService,
        private readonly messages: MessageService
    ) {
    }

    text: string;
    isEn: boolean;

    ngOnInit() {
        this.isEn = this.app.currentLanguage == 'en';

        this.messages.getText(textCode).subscribe(data => {
            this.text = data.find(t => t.Code == textCode)?.Text;
        });
    }
}
